<script>
import { mapGetters } from 'vuex';
import printJS from 'print-js';
import { SHOW_TAGS_VIEW } from '@/config';

export default {
  name: 'AppPage',
  props: {
    laside: {
      type: Object,
      default() {
        return {};
      },
    },
    raside: {
      type: Object,
      default() {
        return {};
      },
    },
    fheader: {
      type: Object,
      default() {
        return {};
      },
    },
    dialog: {
      type: Object,
      default() {
        return {};
      },
    },
    drawer: {
      type: Object,
      default() {
        return {};
      },
    },
    query: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      contentHeight: 0,
      timer: null,
      collapse: false,
      showTagsView: SHOW_TAGS_VIEW,
    };
  },
  computed: {
    ...mapGetters('app', [
      'showVersionTip',
    ]),
    appPageStyle() {
      let style = '';
      if (this.showTagsView) {
        style = 'height:calc(100vh - 98px)';
      } else {
        style = this.showVersionTip ? 'height:calc(100vh - 64px - 40px)' : 'height:calc(100vh - 64px)';
      }
      return style;
    },
  },
  watch: {
    query: {
      handler() {
        Object.entries(this.query).forEach(([key, value]) => {
          if (Object.prototype.toString.call(value) === '[object Object]') {
            this.query[key] = JSON.stringify(value);
          }
        });
        this.$router.replace({ name: this.$route.name, query: this.query });
      },
      deep: true,
      // immediate: true,
    },
  },
  activated() {
    this.computedContentHeight();
  },
  mounted() {
    this.computedContentHeight();
    window.addEventListener('resize', this.windowResizeCallBack, false);
  },
  destroyed() {
    window.removeEventListener('resize', this.windowResizeCallBack, false);
  },
  methods: {
    windowResizeCallBack() {
      if (this.timer) return;
      this.timer = setTimeout(() => {
        this.timer = null;
        this.computedContentHeight();
      }, 600);
    },
    computedContentHeight() {
      const { contentWrapper, contentMain, contentHeader } = this.$refs;
      if (contentWrapper && contentMain) {
        const height = contentWrapper.$el.clientHeight;
        const { paddingTop, paddingBottom } = getComputedStyle(contentMain.$el);
        // 8是盒子差距大概
        this.contentHeight = height - parseInt(paddingTop || '0', 10) - parseInt(paddingBottom || '0', 10) - 8;
        // 如果有内容头部，需要减去
        if (contentHeader) {
          const mainHeader = contentHeader.$el.clientHeight;
          this.contentHeight -= mainHeader;
        }
      }
    },
    printJSON({ header, printable, properties }) {
      printable.forEach((item) => properties.forEach(({ field, format }) => {
        if (format) item[field] = format(item[field]);
      }));
      printJS({
        type: 'json',
        header,
        printable,
        properties,
        gridHeaderStyle: 'border:2px solid #666;padding:5px;',
        gridStyle: 'border:2px solid #666;padding:5px;',
      });
    },
    printHTML() {
      throw new Error('Method not implemented.');
    },
    print(configuration = {}) {
      printJS({ ...configuration });
    },
  },
  render() {
    const { row = {}, col, showCollapse = false } = this.fheader;
    let fheaderVNode;
    if (this.$scopedSlots.fheader) {
      fheaderVNode = this.$scopedSlots.fheader({ collapse: this.collapse });
      fheaderVNode.forEach(({ componentOptions = {} }) => {
        if (componentOptions.tag === 'el-form') {
          componentOptions.children = [
            <el-row {...{ props: { gutter: 10, ...row } }}>
              {componentOptions.children.map((item) => {
                const options = item.componentOptions || {};
                if (options.tag !== 'el-form-item') return item;
                return (
                  <el-col
                    {...{
                      props: { ...(col || { xs: 24, sm: 12, md: 12, lg: 8, xl: 6 }) },
                    }}
                  >
                    {item}
                  </el-col>
                );
              })}
            </el-row>,
          ];
        }
      });
    }
    return (
      <el-card class="app-page" style={this.appPageStyle}>
        {this.$scopedSlots.default && this.$scopedSlots.default()}
        <el-container>
          {this.$scopedSlots.laside && (
            <el-aside class="page-left-aside" {...{ props: this.laside }}>
              {this.$scopedSlots.laside()}
            </el-aside>
          )}
          <el-container class="page-center-container">
            {this.$scopedSlots.fheader && (
              <el-header class="page-fixed-header">
                {fheaderVNode}
                {showCollapse && (
                  <div
                    onClick={() => {
                      this.collapse = !this.collapse;
                    }}
                    class="page-fixed-header-collapse"
                  >
                    {this.collapse ? '展开' : '收起'}
                    <i class={`el-icon-arrow-${this.collapse ? 'down' : 'up'}`} />
                  </div>
                )}
              </el-header>
            )}
            <el-main class="page-content" ref="contentWrapper">
              {this.$scopedSlots.header && (
                <el-header class="page-header" ref="contentHeader">{this.$scopedSlots.header()}</el-header>
              )}
              {this.$scopedSlots.main && (
                <el-main
                  ref="contentMain"
                  style={showCollapse ? 'padding-top:35px' : ''}
                  class="page-main"
                >
                  {this.$scopedSlots.main({ height: this.contentHeight })}
                </el-main>
              )}
              {this.$scopedSlots.footer && (
                <el-footer class="page-footer">{this.$scopedSlots.footer()}</el-footer>
              )}
            </el-main>
            {this.$scopedSlots.ffooter && (
              <el-footer class="page-fixed-footer">{this.$scopedSlots.ffooter()}</el-footer>
            )}
          </el-container>
          {this.$scopedSlots.raside && (
            <el-aside class="page-right-aside" {...{ props: this.raside }}>
              {this.$scopedSlots.raside()}
            </el-aside>
          )}
          {Object.entries(this.dialog).map(
            ([dialogName, { destroyOnClose = true, title, footer, ...dialogProps }]) => {
              return (
                this.$scopedSlots[dialogName]
                && this.dialog[dialogName].visible && (
                  <el-dialog
                    {...{ props: { destroyOnClose, ...dialogProps } }}
                    onClose={() => {
                      this.dialog[dialogName].visible = false;
                    }}
                  >
                    {this.$scopedSlots[dialogName]()}
                    <div class="el-dialog__title" slot="title">
                      {title}
                    </div>
                    <template slot="footer">{footer}</template>
                  </el-dialog>
                )
              );
            },
          )}
          {Object.entries(this.drawer).map(
            ([
              drawerName,
              { withHeader = false, destroyOnClose = true, title, ...dialogProps },
            ]) => {
              return (
                this.$scopedSlots[drawerName]
                && this.drawer[drawerName].visible && (
                  <el-drawer
                    {...{ props: { withHeader, destroyOnClose, ...dialogProps } }}
                    onClose={() => {
                      this.drawer[drawerName].visible = false;
                    }}
                  >
                    <div class="page-drawer">
                      {title && <h3 class="page-drawer-title">{title}</h3>}
                      <div class="page-drawer-content">{this.$scopedSlots[drawerName]()}</div>
                    </div>
                  </el-drawer>
                )
              );
            },
          )}
        </el-container>
      </el-card>
    );
  },
};
</script>

<style lang="scss" scoped>
.app-page {
  // overflow-x: auto;
  ::v-deep {
    .el-card__body {
      height: 100%;
      padding: 0;
    }
    .el-container {
      height: 100%;
    }
    .el-header {
      height: auto !important;
      padding: 0;
    }
    .el-main {
      padding: 0;
    }
    .el-footer {
      height: auto !important;
      padding: 0;
    }
  }
  .page-left-aside {
    padding: 16px;
    overflow-x: hidden;
    box-shadow: 2px 0 6px rgba(0, 21, 41, 0.15);
  }
  .page-center-container {
    width: auto;
    background: #f7f9fd;
    padding: 0px 8px 8px;
  }
  .page-right-aside {
    padding: 16px;
    overflow-x: hidden;
    box-shadow: -2px 0 6px rgba(0, 21, 41, 0.15);
  }
  .page-fixed-header {
    position: relative;
    height: auto !important;
    padding: 16px 20px 0;
    box-shadow: 1px 0px 11px 0px rgba(39, 39, 40, 0.06);
    margin: 0px -16px;
    background: #fff;
    ::v-deep {
      .el-form {
        width: 100%;
      }
      .el-form-item {
        margin-bottom: 16px;
        &.label-hidden {
          .el-form-item__label {
            display: none;
          }
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }
      .el-date-editor {
        width: 100%;
      }
      .el-select {
        width: 100%;
      }
    }
    .page-fixed-header-collapse {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: -24px;
      transform: translateX(-50%);
      font-size: 14px;
      padding: 5px 20px;
      color: #606266;
      background: #fff;
      border-radius: 0 0 4px 4px;
      box-shadow: 0 5px 6px rgba(0, 21, 41, 0.1);
      user-select: none;
      cursor: pointer;
      [class^="el-icon-"] {
        font-size: 14px;
        font-weight: 600;
        margin-left: 3px;
        color: #606266;
      }
    }
  }
  .page-fixed-footer {
    height: auto !important;
    overflow-x: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px 16px;
    background: #fff;
    //  box-shadow: 0 -2px 6px rgba(0, 21, 41, 0.15);
    ::v-deep .el-pagination {
      white-space: nowrap;
      margin-left: 30px;
    }
  }
  .page-content {
    margin: 0px;
    padding-top: 8px;
    .page-header {
      height: auto !important;
      // display: flex;
      // justify-content: space-between;
      // align-items: center;
      padding: 16px 16px 0;
      background: #fff;
      ::v-deep .el-form-item {
        margin-bottom: 0;
      }
    }
    .page-main {
      padding: 16px;
      background: #fff;
    }
    .page-footer {
      height: auto !important;
      overflow-x: auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px 16px;
      ::v-deep .el-pagination {
        white-space: nowrap;
        margin-left: 30px;
      }
    }
  }
  .page-drawer {
    width: 100%;
    height: 100%;
    padding: 16px;
    .page-drawer-title {
      line-height: 24px;
      font-size: 18px;
      color: #303133;
      padding-bottom: 20px;
      & + .page-drawer-content {
        padding: 0 5px;
      }
    }
  }
}
</style>
